import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import classes from './Sidebar.module.css';

const Sidebar = () => {
  const location = useLocation();
  
  const isDevicesActive = location.pathname.startsWith('/devices');
  const isProjectsActive = location.pathname.startsWith('/project');

  return (
    <aside className={classes.sidebar}>
      <nav className={classes.nav}>
        <NavLink
          to="/overview"
          className={({ isActive }) => 
            `${classes.navItem} ${isActive ? classes.navItemActive : ''}`
          }
        >
          Overview
        </NavLink>
        <NavLink
          to="/devices"
          className={({ isActive }) => 
            `${classes.navItem} ${isActive || isDevicesActive ? classes.navItemActive : ''}`
          }
        >
          Devices
        </NavLink>
        <NavLink
          to="/projects"
          className={({ isActive }) => 
            `${classes.navItem} ${isActive || isProjectsActive ? classes.navItemActive : ''}`
          }
        >
          Projects
        </NavLink>
        <NavLink
          to="/download"
          className={({ isActive }) => 
            `${classes.navItem} ${isActive ? classes.navItemActive : ''}`
          }
        >
          Download
        </NavLink>
      </nav>
    </aside>
  );
};

export default Sidebar;

